import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { 
    Container, 
    Table, 
    Badge, 
    Modal, 
    Button, 
    Form, 
    Alert, 
    Spinner,
    DropdownButton,
    Dropdown ,Image,Row,Col,Tab,Tabs,Pagination
} from 'react-bootstrap';

// Import Firestore functions
import { db, storage } from '../FireBase'; // Ensure correct path and case
import { 
    collection, 
    addDoc, 
    query, 
    orderBy, 
    onSnapshot, 
    deleteDoc, 
    doc, 
    updateDoc ,
    where,getDocs,getDoc,setDoc
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as XLSX from 'xlsx'; // Import xlsx for Excel export
import ToastAlert from '../components/ToastAlert';
import { generateExcelReport } from '../components/reportUtils';
import { faFileExcel, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import "../css/inventory.css";
import { FaArrowRotateLeft, FaTrash } from 'react-icons/fa6';
import Loading from '../components/Loading';

const Inventory = () => {
    
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    // Alert state
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const [loading, setLoading] = useState(false);

    // Categories state
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showProductModal, setShowProductModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false); // To distinguish between editing and adding
    const [productImage, setProductImage] = useState('');
    const [showStockModal, setShowStockModal] = useState(false);
    const [selectedStockProduct, setSelectedStockProduct] = useState(null);
    const [activeTab, setActiveTab] = useState('inventory');
    const [stockManagementData, setStockManagementData] = useState([]);


    // Pagination states for inventory
    const [currentPageInventory, setCurrentPageInventory] = useState(1);
    const itemsPerPage = 50;
    const indexOfLastItemInventory = currentPageInventory * itemsPerPage;
    const indexOfFirstItemInventory = indexOfLastItemInventory - itemsPerPage;
    const currentItemsInventory = filteredProducts.slice(indexOfFirstItemInventory, indexOfLastItemInventory);

    // Pagination states for stock management
    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
    const [currentPageStock, setCurrentPageStock] = useState(1);
    const indexOfLastItemStock = currentPageStock * itemsPerPage;
    const indexOfFirstItemStock = indexOfLastItemStock - itemsPerPage;
    const currentItemsStock = stockManagementData.slice(indexOfFirstItemStock, indexOfLastItemStock);
    const [showOutwardStockModal, setShowOutwardStockModal] = useState(false);
    const [selectedOutwardStock, setSelectedOutwardStock] = useState(null);
    const [selectedPriceRangeIndex, setSelectedPriceRangeIndex] = useState(null);
    const [galleryImages, setGalleryImages] = useState([]);
    const [imageUploading, setImageUploading] = useState(false);
    const [deletedProducts,setDeletedProducts] = useState([]);
// Function to handle page change for inventory
    const paginateInventory = (pageNumber) => setCurrentPageInventory(pageNumber);
    const totalPages2 = Math.ceil(stockManagementData.length / itemsPerPage);
    // Function to handle page change for stock management
    const paginateStock = (pageNumber) => setCurrentPageStock(pageNumber);
 const[LoadingPage,setLoadingPage]= useState(false);

    const fetchProductsData = async () => {
        try {
          
            const productsQuery = query(
                collection(db, 'products'),
                orderBy('createdAt', 'desc') // descending by addedDate
            );
            const querySnapshot = await getDocs(productsQuery);
            const productList = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }))
            .filter((doc) => doc.deleted !== true);
            setProducts(productList);
            setFilteredProducts(productList);
        } catch (error) {
            console.error('Error fetching products:', error);
        }finally{
          
        }
    };
    const fetchDeletedProducts = async()=>{
        try{
           
            setLoading(true);
            const deletedProductsQuery=query(
                collection(db, 'products'),
                where('deleted', '==', true),
                orderBy('deletedAt', 'desc')
            );
            const deletedQuerySnapshot=await getDocs(deletedProductsQuery);
            const deletedProductList=deletedQuerySnapshot.docs.map(doc=>({
                ...doc.data(),
                id:doc.id,
            }));
            setDeletedProducts(deletedProductList);
            setLoading(false);
        }catch(error){
            console.error("Error fetching deleted products:", error);
            setLoading(false);
        }finally{
          
        }
    }

    useEffect(() => {
        fetchData();
     
        
    }, []);
    const fetchData = async () => {
        setLoadingPage(true);
        await fetchStockManagementData();
        await fetchProductsData();
        await fetchStockManagementData();
        await fetchDeletedProducts();
        setLoadingPage(false);
    };

    // Function to handle opening the modal for adding a product
    const handleShowAddProductModal = () => {
        setSelectedProduct({
            customId: generateCustomId(), // Renamed from 'id' to 'customId'
            sku: '',
            name: '',
            unitType: '',
            unitValue: '',
            barcode: '',
            priceRanges: [{ price: '', stock: '' }], // Initialize with one price range
            createdAt: new Date(),
        });
        setIsEditing(false);
        setShowProductModal(true);
    };

    // Function to handle opening the modal for editing a product
    const handleEditProduct = (product) => {
        setSelectedProduct(product);
        setProductImage(product.productImage || '');
        setIsEditing(true);
        setShowProductModal(true);
        setGalleryImages(product.galleryImages || '');
    };

    // Function to handle closing the product modal
    const handleCloseProductModal = () => {
        setSelectedProduct(null);
        setShowProductModal(false);
        setProductImage(''); // Clear the product image
        setGalleryImages('');
    };
    const handleDeleteProduct = async (productId) => {
        if (window.confirm('Are you sure you want to delete this product?')) {
            try {
                const productRef = doc(db,'products',productId);
                await updateDoc(productRef,{
                    deleted:true,
                    deletedAt:new Date().toISOString(),
                });
                setToastMessage('Product deleted successfully');
                setToastVariant('danger'); // or 'danger', 'warning', etc.
                setShowToast(true);
                fetchData();
            } catch (error) {
                console.error('Error deleting product:', error);
                setToastMessage('Error deleting product. Please try again.');
                setToastVariant('warning'); // or 'danger', 'warning', etc.
                setShowToast(true);
            }
            handleCloseProductModal();
            fetchProductsData();
        }
    };
    const handleRecoverProduct = async (productId) => {
        if (window.confirm('Are you sure you want to recover this product?')) {
            try {
                const productRef = doc(db,'products',productId);
                await updateDoc(productRef,{
                    deleted:false,
                    deletedAt:new Date().toISOString(),
                });
                setToastMessage('Product redo successfully');
                setToastVariant('success'); // or 'danger', 'warning', etc.
                setShowToast(true);
                fetchData();
            } catch (error) {
                console.error('Error deleting product:', error);
                setToastMessage('Error deleting product. Please try again.');
                setToastVariant('warning'); // or 'danger', 'warning', etc.
                setShowToast(true);
            }
            handleCloseProductModal();
            fetchProductsData();
        }
    };

    // Function to handle deleting a product
    const handleDeleteProductFully = async (productId) => {
        if (window.confirm('Are you sure you want to delete this product?')) {
            try {
                await deleteDoc(doc(db, 'products', productId));
                setToastMessage('Product deleted successfully');
                setToastVariant('danger'); // or 'danger', 'warning', etc.
                setShowToast(true);
                fetchData();
            } catch (error) {
                console.error('Error deleting product:', error);
                setToastMessage('Error deleting product. Please try again.');
                setToastVariant('warning'); // or 'danger', 'warning', etc.
                setShowToast(true);
            }
            handleCloseProductModal();
            fetchProductsData();
        }
    };

    const handleImageUpload = async (file) => {
        if (!file) return;
        const storageRef = ref(storage, `productImages/${file.name}`);
        try {
            setImageUploading(true);
            await uploadBytes(storageRef, file);
            const downloadURL = await getDownloadURL(storageRef);
            setProductImage(downloadURL);
            setSelectedProduct({ ...selectedProduct, productImage: downloadURL });
            setImageUploading(false);
        } catch (error) {
            console.error('Error uploading image:', error);
            setToastMessage('Error uploading image');
            setToastVariant('danger');
            setShowToast(false);
        }
        finally{
            setImageUploading(false);
        }
    };
    const handleSaveProduct = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const productData = {
                sku: selectedProduct.sku,
                name: selectedProduct.name,
                unitValue: selectedProduct.unitValue,
                unitType: selectedProduct.unitType,
                barcode: selectedProduct.barcode,
                createdAt: selectedProduct.createdAt || new Date(),
                productImage: selectedProduct.productImage || '',
                galleryImages,
            };
            
            const productCollection = collection(db, "products");
    
            // Check for existing SKU
            const skuQuery = query(productCollection, where("sku", "==", selectedProduct.sku));
            const querySnapshot = await getDocs(skuQuery);
        
            if (!querySnapshot.empty && !isEditing) {
                setToastMessage('The SKU already exists. Please use a different SKU.');
                setToastVariant('warning');
                setShowToast(true);
                return;
            }

            const barCodeQuery = query(productCollection, where("barcode", "==", selectedProduct.barcode));
            const barCodequerySnapshot = await getDocs(barCodeQuery);
        
            if (!barCodequerySnapshot.empty && !isEditing) {
                setToastMessage('The barcode already exists. Please use a different Barcode.');
                setToastVariant('warning');
                setShowToast(true);
                return;
            }
    
            if (isEditing && selectedProduct.id) {
                const productRef = doc(db, 'products', selectedProduct.id);
                await updateDoc(productRef, productData);
                setToastMessage('Product updated successfully!');
            } else {
                await addDoc(collection(db, 'products'), productData);
                setToastMessage('Product added successfully!');
            }
    
            setToastVariant('success');
            setShowToast(true);
            fetchProductsData();
            handleCloseProductModal();
        } catch (error) {
            console.error('Error saving product:', error);
            setToastMessage('Something went wrong while saving the product.');
            setToastVariant('warning');
            setShowToast(true);
        } finally {
            fetchData();
            setLoading(false);
        }
    };
  

    // Function to generate unique custom ID for new products
    const generateCustomId = () => {
        // You can implement a more robust ID generation strategy
        const nextId = products.length + 1;
        return 'PROD' + String(nextId).padStart(3, '0');
    };

    // Filter products based on searchTerm
    useEffect(() => {
        const lowerCaseSearch = searchTerm.toLowerCase();
        const filtered = products.filter(product =>
            product.name.toLowerCase().includes(lowerCaseSearch)
        );
        setFilteredProducts(filtered);
    }, [searchTerm, products]);

  
const downloadReport = () => {
    // Data for the inventory sheet
    const inventorySheet = {
        name: 'Products',
        data: [
            ['Product ID', 'SKU', 'Name', 'Unit value', 'Unit type', 'Price', 'Stock'],
            ...products.map(product => [
                product.id,
                product.sku,
                product.name,
                product.unitValue,
                product.unitType,
                product.priceRanges ? product.priceRanges.map(pr => pr.price).join(', ') : '', // Join multiple prices with a comma
                product.priceRanges ? product.priceRanges.map(pr => pr.stock).join(', ') : '' // Join multiple stocks with a comma
            ])
        ]
    };

    // Data for the stock history sheet
    const stockHistorySheet = {
        name: 'Stock History',
        data: [
            ['Product Name', 'Price', 'Stock', 'Type', 'Timestamp', 'Vendor Name', 'Invoice Number', 'Scheme Name', 'Customer ID'],
            ...stockManagementData.map(stock => [
                stock.productName,
                stock.priceRanges ? stock.priceRanges.map(pr => pr.price).join(', ') : '',
                stock.priceRanges ? stock.priceRanges.map(pr => pr.stock).join(', ') : '',
                stock.type,
                new Date(stock.updatedAt.seconds * 1000).toLocaleString(),
                stock.type === 'Inward-stock' ? stock.vendorname : '',
                stock.type === 'Inward-stock' ? stock.invoicenumber : '',
                stock.type === 'Outward-stock' ? stock.schemeName : '',
                stock.type === 'Outward-stock' ? stock.customerId : ''
            ])
        ]
    };

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create the inventory sheet
    const wsInventory = XLSX.utils.aoa_to_sheet(inventorySheet.data);
    XLSX.utils.book_append_sheet(wb, wsInventory, inventorySheet.name);

    // Create the stock history sheet
    const wsStockHistory = XLSX.utils.aoa_to_sheet(stockHistorySheet.data);
    XLSX.utils.book_append_sheet(wb, wsStockHistory, stockHistorySheet.name);

    // Write the workbook to a file
    XLSX.writeFile(wb, 'Inventory_Report.xlsx');
};
    const handleSaveStock = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
    
            console.log("Fetching existing product...");
            console.log("Selected Stock Product:", selectedStockProduct);
            console.log("Selected Price Range Index:", selectedPriceRangeIndex);
    
            if (!selectedStockProduct?.priceRanges || selectedStockProduct.priceRanges.length === 0) {
                throw new Error("No price ranges available for this product.");
            }
    
            if (selectedPriceRangeIndex === undefined || selectedPriceRangeIndex < 0 || selectedPriceRangeIndex >= selectedStockProduct.priceRanges.length) {
                throw new Error("Invalid selected price range index.");
            }
    
            // Fetch the existing product
            const productRef = doc(db, "products", selectedStockProduct.id);
            const productDoc = await getDoc(productRef);
    
            if (!productDoc.exists()) {
                throw new Error("Product not found");
            }
    
            console.log("Existing Product Data:", productDoc.data());
    
            // Update the stock
            const updatedPriceRanges = selectedStockProduct.priceRanges.map((priceRange, index) => {
                try {
                    console.log("Checking index", index, "with priceRange", priceRange);
            
                    if (Number(index) === Number(selectedPriceRangeIndex)) {
                        const currentStock = Number(priceRange.stock) || 0;
                        const inwardStock = Number(priceRange.inwardStock) || 0;
                        const updatedStock = currentStock + inwardStock;
                        setTimeout(() => {
                        console.log(`✅ Updating stock at index ${index} - Current Stock: ${currentStock}, Inward Stock: ${inwardStock}, Updated Stock: ${updatedStock}`);
                        }, 0);
                        return {
                            ...priceRange,
                            stock: updatedStock, // ✅ Correctly adding the inward stock
                            mrp: priceRange.mrp,
                            price: priceRange.price,
                        };
                    } else {
                        console.log("⚠️ No stock update needed for index", index);
                    }
                } catch (error) {
                    console.error("Error in stock update mapping:", error);
                }
                return priceRange;
            }).map(({ date, vendorname, invoicenumber,inwardStock, ...rest }) => rest); 
            
    
            console.log("Updated Price Ranges:", updatedPriceRanges);
    
            // Update the product document in Firestore
            await updateDoc(productRef, {
                priceRanges: updatedPriceRanges,
            });
    
            console.log("Stock successfully updated in Firestore!");
    
            // Log the updated price range for stock management entry
            const updatedPriceRange = selectedStockProduct.priceRanges[selectedPriceRangeIndex];
            console.log("Stock Data to Save:", updatedPriceRange);
    
            // Add stock movement entry
            await addDoc(collection(db, "stock-management"), {
                productId: selectedStockProduct.id,
                priceRanges: [
                    {
                        price: updatedPriceRange.price,
                        stock: Number(updatedPriceRange.inwardStock) || 0,
                    },
                ],
                updatedAt: new Date(),
                type: "Inward-stock",
                vendorname: updatedPriceRange.vendorname || "",
                invoicenumber: updatedPriceRange.invoicenumber || "",
                date: updatedPriceRange.date || new Date(),
            });
    
            console.log("Stock entry successfully added to stock-management!");
    
            // Show success message
            setToastMessage("Stock updated successfully!");
            setToastVariant("success");
            setShowToast(true);
            fetchProductsData();
            handleCloseStockModal();
        } catch (error) {
            console.error("Error saving stock:", error);
            setToastMessage("Something went wrong while saving the stock.");
            setToastVariant("warning");
            setShowToast(true);
        } finally {
            fetchData();
            setLoading(false);
        }
    };
    
    
    const handleShowStockModal = (product) => {
        // Ensure priceRanges is initialized
        if (!product.priceRanges) {
            product.priceRanges = [{ price: '', stock: '', mrp: '', date: '', vendorname: '', invoicenumber: '' }];
        }
        setSelectedStockProduct(product);
        setSelectedPriceRangeIndex(null); // Reset the selected price range index
        setShowStockModal(true);
    };
        const handleCloseStockModal = () => {
            setSelectedStockProduct(null);
            setShowStockModal(false);
        };

        const fetchStockManagementData = async () => {
            try {
                const querySnapshot = await getDocs(query(collection(db, 'stock-management'), orderBy('updatedAt', 'desc')));
                const stockDataList = await Promise.all(querySnapshot.docs.map(async (docSnapshot) => {
                    const stockData = docSnapshot.data();
                  
                    const productDoc = await getDoc(doc(db, 'products', stockData.productId));
                    const productName = productDoc.exists() ? productDoc.data().name : 'Unknown Product';
                    return {
                        id: docSnapshot.id,
                        ...stockData,
                        productName,
                    };
                }));
                setStockManagementData(stockDataList);
              
            } catch (error) {
                console.error('Error fetching stock management data:', error);
            }
        };


const handleDeletePriceRange = async () => {
    if (selectedPriceRangeIndex !== null && selectedPriceRangeIndex >= 0) {
        if (window.confirm("Are you sure you want to delete this price range?")) {
            try {
                const updatedPriceRanges = [...selectedStockProduct.priceRanges];
                updatedPriceRanges.splice(selectedPriceRangeIndex, 1); // Remove the selected range

                // Update Firestore
                const productRef = doc(db, "products", selectedStockProduct.id); // Adjust collection name
                await updateDoc(productRef, { priceRanges: updatedPriceRanges });

                // Update local state
                setSelectedStockProduct(prev => ({
                    ...prev,
                    priceRanges: updatedPriceRanges
                }));

                setSelectedPriceRangeIndex(null); // Reset selection after deletion
                alert("Price range deleted successfully!");
            } catch (error) {
                console.error("Error deleting price range:", error);
                alert("Failed to delete price range. Please try again.");
            }
        }
    }
};
const handleGalleryImageUpload = async (files) => {
    const uploadedImages = [];
    try {
        setImageUploading(true);
        for (const file of files) {
            const storageRef = ref(storage, `productGalleryImages/${file.name}`);
            await uploadBytes(storageRef, file);
            const downloadURL = await getDownloadURL(storageRef);
            uploadedImages.push(downloadURL); // Add the uploaded image URL to the temporary state
        }
        setGalleryImages([...galleryImages, ...uploadedImages]); // Add new images to the existing gallery
        setToastMessage('Gallery images uploaded successfully!');
        setToastVariant('success');
        setImageUploading(false);
    } catch (error) {
        console.error('Error uploading gallery images:', error);
        setToastMessage('Error uploading gallery images.');
        setToastVariant('danger');
        setShowToast(false);

    } finally {
        setImageUploading(false);
    }
};

// Function to remove a gallery image from the temporary state
const handleRemoveGalleryImage = (index) => {
    const updatedGalleryImages = [...galleryImages];
    updatedGalleryImages.splice(index, 1); // Remove the selected image by index
    setGalleryImages(updatedGalleryImages);
};
if (LoadingPage) {
    // Render loading screen
    
    return (
      <div className="loading-screen">
        
      <Loading/>
      </div>
    );
  }
    return (
        <Container fluid className=" p-4">
            {/* Alert for success or error */}
            <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
            <div className="d-flex justify-content-between align-items-center">
                <h1 className='flex-grow-1'>Inventory</h1>
                <Button  className="btn me-2" variant='info'  onClick={handleShowAddProductModal}>
                    <FontAwesomeIcon icon={faPlus} className="fa-icon" /> Add New Product
                </Button>
                <Button variant="success" className='btn btn me-2' onClick={downloadReport}>
                    <FontAwesomeIcon icon={faFileExcel} className="fa-icon" /> Download Report
                </Button>
            </div>
            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
    <Tab eventKey="inventory" title="Products">
        <div className="d-flex justify-content-between mb-3">
            <input
                type="text"
                className="form-control me-2"
                placeholder="Search products by ID, SKU, Name, or Description"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div></div>
        </div>
        {/* Inventory Table */}
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>SKU</th>
                    <th>Name</th>
                    <th>Mesurement</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {currentItemsInventory.length > 0 ? (
                    currentItemsInventory.map((product, index) => (
                        <tr key={product.id}>
                            <td>{index + 1}</td>
                            <td>
                                {product.productImage ? (
                                    <img
                                        src={product.productImage}
                                        alt={product.name}
                                        width="70"
                                        height="70"
                                        style={{ borderRadius: '20%' }}
                                    />
                                ) : (
                                    'No Image'
                                )}
                            </td>
                            <td>{product.sku}</td>
                            <td>{product.name}</td>
                            <td>{product.unitValue} {product.unitType}</td>
                            <td>
                                <DropdownButton id={`dropdown-${product.id}`} title="" variant="secondary" size="sm">
                                    <Dropdown.Item onClick={() => handleEditProduct(product)}>Edit</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleDeleteProduct(product.id)}>Delete</Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleShowStockModal(product)}>Manage Stock</Dropdown.Item>
                                </DropdownButton>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="10" className="text-center">
                            No products found.
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
        
    <div style={{ overflowX: 'auto' }}>
 
  <Pagination className="custom-pagination">
  {currentPageInventory > 3 && (
    <>
      <Pagination.Item onClick={() => paginateInventory(1)}>1</Pagination.Item>
      <Pagination.Ellipsis disabled />
    </>
  )}

  {Array.from({ length: 5 }, (_, i) => {
    const page = currentPageInventory - 2 + i;
    if (page > 0 && page <= totalPages) {
      return (
        <Pagination.Item
          key={page}
          active={page === currentPageInventory}
          onClick={() => paginateInventory(page)}
        >
          {page}
        </Pagination.Item>
      );
    }
    return null;
  })}

  {currentPageInventory < totalPages - 2 && (
    <>
      <Pagination.Ellipsis disabled />
      <Pagination.Item onClick={() => paginateInventory(totalPages)}>{totalPages}</Pagination.Item>
    </>
  )}
</Pagination>
</div>

        
    </Tab>
    <Tab eventKey="stockManagement" title="Stock History">
        {/* Stock Management Table */}
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Product Name</th>
                    <th>Price</th>
                    <th>Stock</th>
                    <th>Type</th>
                    <th>Time stamp</th>
                </tr>
            </thead>
                <tbody>
                    {currentItemsStock.length > 0 ? (
                        currentItemsStock.map((stock, index) => (
                            <tr key={stock.id} style={{cursor:'pointer'}} onClick={() => {
                               
                                    setSelectedOutwardStock(stock);
                                    setShowOutwardStockModal(true);
                              
                                
                            }}>
                                <td>{index + 1}</td>
                                <td>{stock.productName}</td>
                                <td>{stock.priceRanges.map(pr => pr.price).join(', ')}</td>
                                <td>{stock.priceRanges.map(pr => pr.stock).join(', ')}</td>
                                <td style={{ color: stock.type === 'Inward-stock' ? 'green' : 'red' }}>
                                    {stock.type}
                                </td>
                                <td>{new Date(stock.updatedAt.seconds * 1000).toLocaleString()}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7" className="text-center">
                                No stock management data found.
                            </td>
                        </tr>
                    )}
            </tbody>
        </Table>
       
        
        <div style={{ overflowX: 'auto' }}>
 
            <Pagination className="custom-pagination">
            {currentPageStock > 3 && (
                <>
                <Pagination.Item onClick={() => paginateStock(1)}>1</Pagination.Item>
                <Pagination.Ellipsis disabled />
                </>
            )}

            {Array.from({ length: 5 }, (_, i) => {
                const page = currentPageStock - 2 + i;
                if (page > 0 && page <= totalPages2) {
                return (
                    <Pagination.Item
                    key={page}
                    active={page === currentPageStock}
                    onClick={() => paginateStock(page)}
                    >
                    {page}
                    </Pagination.Item>
                );
                }
                return null;
            })}

            {currentPageInventory < totalPages2 - 2 && (
                <>
                <Pagination.Ellipsis disabled />
                <Pagination.Item onClick={() => paginateStock(totalPages2)}>{totalPages2}</Pagination.Item>
                </>
            )}
            </Pagination>
            </div>
    </Tab>
    <Tab eventKey="bin" title="Bin">
    <div className="d-flex justify-content-between mb-3">
            <input
                type="text"
                className="form-control me-2"
                placeholder="Search products by ID, SKU, Name, or Description"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div></div>
        </div>
        {/* Inventory Table */}
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>SKU</th>
                    <th>Name</th>
                    <th>Mesurement</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {deletedProducts.length > 0 ? (
                    deletedProducts.map((product, index) => (
                        <tr key={product.id}>
                            <td>{index + 1}</td>
                            <td>
                                {product.productImage ? (
                                    <img
                                        src={product.productImage}
                                        alt={product.name}
                                        width="70"
                                        height="70"
                                        style={{ borderRadius: '20%' }}
                                    />
                                ) : (
                                    'No Image'
                                )}
                            </td>
                            <td>{product.sku}</td>
                            <td>{product.name}</td>
                            <td>{product.unitValue} {product.unitType}</td>
                            <td>
                              
                                 <Button variant="outline-success" className="btn m-1" onClick={() => handleRecoverProduct(product.id)} style={{ marginLeft: '5px' }}>
                                    <FaArrowRotateLeft  className="fa-icon" /> 
                                </Button>
                                <Button variant="outline-danger" className="btn m-1" onClick={() => handleDeleteProductFully(product.id)} style={{ marginLeft: '5px' }}>
                                    <FaTrash  className="fa-icon" /> 
                                </Button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="10" className="text-center">
                            No products found.
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
        
        {/* <Pagination className="custom-pagination">
            {Array.from({ length: Math.ceil(filteredProducts.length / itemsPerPage) }, (_, index) => (
                <Pagination.Item key={index + 1} active={index + 1 === currentPageInventory} onClick={() => paginateInventory(index + 1)}>
                    {index + 1}
                </Pagination.Item>
            ))}
        </Pagination> */}
    </Tab>
</Tabs>
        
            {/* Search Bar and Action Buttons */}
           

        
            {/* Modal for Adding/Editing Product */}
            <Modal show={showProductModal} onHide={handleCloseProductModal} size="lg" centered>
    <Modal.Header closeButton>
        <Modal.Title>{isEditing ? 'Edit product' : 'Add new product'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {selectedProduct && (
            <Form onSubmit={handleSaveProduct}>
                {/* SKU */}
                <Form.Group className="mb-3" controlId="formProductSKU">
                    <Form.Label>SKU</Form.Label>
                    <Form.Control 
                        type="text" 
                        value={selectedProduct.sku || ''} 
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, sku: e.target.value })}
                        required
                    />
                </Form.Group>
            
                {/* Product Name */}
                <Form.Group className="mb-3" controlId="formProductName">
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control 
                        type="text" 
                        value={selectedProduct.name || ''} 
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, name: e.target.value })}
                        required
                        placeholder="Enter the product name"
                    />
                </Form.Group>
            
                {/* Unit of Measurement */}
                <Form.Group className="mb-3" controlId="formMeasurement">
                    <Form.Label>Unit of Measurement</Form.Label>
                    <Row>
                        <Col md={8}>
                            <Form.Control 
                                type="number" 
                                value={selectedProduct.unitValue || ''} 
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, unitValue: e.target.value })}
                                required
                                placeholder="Enter the unit value"
                            />
                        </Col>
                        <Col md={4}>
                            <Form.Select 
                                value={selectedProduct.unitType || ''} 
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, unitType: e.target.value })} 
                                required
                            >
                                <option value="" disabled>Select Unit</option>
                                <option value="Grms">Grms</option>
                                <option value="Kg">Kg</option>
                                <option value="Packet">Packet</option>
                                <option value="Box">Box</option>
                                <option value="Pcs">Pcs</option>
                            </Form.Select>
                        </Col>
                    </Row>
                </Form.Group>
            
                {/* Price Ranges */}
                {/* <Form.Group className="mb-3" controlId="formPriceRanges">
                    <Form.Label>Price Ranges</Form.Label>
                    {selectedProduct.priceRanges.map((priceRange, index) => (
                        <Row key={index} className="mb-2">
                            <Col md={5}>
                                <Form.Control
                                    type="number"
                                    value={priceRange.price}
                                    onChange={(e) => {
                                        const newPriceRanges = [...selectedProduct.priceRanges];
                                        newPriceRanges[index].price = e.target.value;
                                        setSelectedProduct({ ...selectedProduct, priceRanges: newPriceRanges });
                                    }}
                                    placeholder="Enter price"
                                    required
                                />
                            </Col>
                            <Col md={5}>
                                <Form.Control
                                    type="number"
                                    value={priceRange.stock}
                                    onChange={(e) => {
                                        const newPriceRanges = [...selectedProduct.priceRanges];
                                        newPriceRanges[index].stock = e.target.value;
                                        setSelectedProduct({ ...selectedProduct, priceRanges: newPriceRanges });
                                    }}
                                    placeholder="Enter stock"
                                    required
                                />
                            </Col>
                            <Col md={2}>
                                <Button
                                    variant="outline-danger"
                                    className='btn'
                                    onClick={() => {
                                        const newPriceRanges = selectedProduct.priceRanges.filter((_, i) => i !== index);
                                        setSelectedProduct({ ...selectedProduct, priceRanges: newPriceRanges });
                                    }}
                                >
                                X                                
                                </Button>
                            </Col>
                        </Row>
                    ))}
                    <Button
                        variant="outline-primary"
                        className='btn'
                        onClick={() => {
                            const newPriceRanges = [...selectedProduct.priceRanges, { price: '', stock: '' }];
                            setSelectedProduct({ ...selectedProduct, priceRanges: newPriceRanges });
                        }}
                    >
                        Add Price Range
                    </Button>
                </Form.Group> */}
            
                {/* Barcode */}
                <Form.Group className="mb-3" controlId="formProductbarcode">
                    <Form.Label>Barcode</Form.Label>
                    <Form.Control 
                        type="text" 
                        value={selectedProduct.barcode || ''} 
                        onChange={(e) => setSelectedProduct({ ...selectedProduct, barcode: e.target.value })}
                        onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} // Prevent Enter key submission
                        placeholder="Place the cursor here and scan the barcode or enter manually"
                        required
                    />
                </Form.Group>
            <Row>
                <Col>
                      {/* Product Image */}
                <Form.Group className="mb-3" controlId="formProductImage">
                    <Form.Label>Product Image</Form.Label>
                    <Form.Control 
                        type="file"
                        onChange={(e) => handleImageUpload(e.target.files[0])}
                        disabled={imageUploading}
                    />
                </Form.Group>
                {productImage && (
                    <div className="mb-3">
                        <h5>Current Product Image:</h5>
                        <Image 
                            src={productImage} 
                            alt={selectedProduct.name} 
                            fluid 
                            rounded 
                            width="100" 
                            height="100" 
                            style={{ borderRadius: '10%' }}
                        />
                    </div>
                )}
            
                </Col>
                <Col>
                  {/* Gallery Image Upload */} 
                  <Form.Group className="mb-3" controlId="formGalleryImages">
                    <Form.Label>Gallery Images</Form.Label>
                    <Form.Control 
                        type="file"
                        accept="image/*"
                        multiple // Allow multiple file selection
                        disabled={imageUploading}
                        onChange={(e) => handleGalleryImageUpload(e.target.files)}
                    />
                </Form.Group>
                {imageUploading && <Spinner animation="border" size="sm" />}
                {/* List-Style Preview of Uploaded Gallery Images */}
                {galleryImages.length > 0 && (
                    <div className="mt-3">
                        <h5>Gallery Images:</h5>
                        <div style={{ maxHeight: '150px', overflowY: 'auto', marginTop: '10px' }}>
                        <ul className="list-group">
                            {galleryImages.map((image, index) => (
                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={image}
                                            alt={`Gallery ${index}`}
                                            style={{
                                                width: '50px',
                                                height: '50px',
                                                objectFit: 'cover',
                                                borderRadius: '5px',
                                                marginRight: '10px',
                                            }}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => handleRemoveGalleryImage(index)}
                                    >
                                        <FontAwesomeIcon icon={faXmark} size="sm" />
                                    </button>
                                </li>
                            ))}
                        </ul>
                        </div>
                    </div>
                )}
               
                </Col>
            </Row>
              
                            
          
                {/* Action Buttons */}
                <div className="d-flex justify-content-between">
                    <Button
                        variant="outline-success"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                {isEditing ? 'Saving Changes...' : 'Adding Product...'}
                            </>
                        ) : (
                            isEditing ? 'Save Changes' : 'Add Product'
                        )}
                    </Button>
                </div>
            </Form>
        )}
    </Modal.Body>
</Modal>

<Modal show={showStockModal} onHide={handleCloseStockModal} size="md" centered>
    <Modal.Header closeButton>
        <Modal.Title>Manage Stock</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {selectedStockProduct && (
            <Form onSubmit={handleSaveStock}>
                <Form.Group className="mb-3" controlId="formStockPriceRanges">
                    <Form.Label>Price Range</Form.Label>
                    <Form.Control
                        as="select"
                        value={selectedPriceRangeIndex !== null ? selectedPriceRangeIndex : ''}
                        onChange={(e) => setSelectedPriceRangeIndex(e.target.value)}
                    >
                        <option value="" disabled>Select Price Range</option>
                        {selectedStockProduct.priceRanges.map((priceRange, index) => (
                            <option key={index} value={index}>
                                {priceRange.price}
                            </option>
                        ))}
                    </Form.Control>
                    <Button
                        variant="outline-primary"
                        className='btn m-1'
                        onClick={() => {
                            const newPriceRanges = [...selectedStockProduct.priceRanges, { price: '', stock: 0, mrp: '', date: '', vendorname: '', invoicenumber: '' }];
                            setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                            setSelectedPriceRangeIndex(newPriceRanges.length - 1); // Set the new price range as selected
                        }}
                    >
                        Add New Price Range
                    </Button>
                    <Button
                        variant="outline-danger"
                        className="btn m-1"
                        onClick={handleDeletePriceRange}
                        disabled={selectedStockProduct.priceRanges.length === 1 || selectedPriceRangeIndex === null } // Prevent deleting last range
                    >
                        Delete Price Range
                    </Button>
                </Form.Group>
                {selectedPriceRangeIndex !== null && (
                    <>
                        <Form.Group className="mb-3" controlId="formStockPrice">
                            <Form.Label>Purchase Price</Form.Label>
                            <Form.Control
                                type="number"
                                value={selectedStockProduct.priceRanges[selectedPriceRangeIndex].price}
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].price = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Price"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockMRP">
                            <Form.Label>MRP</Form.Label>
                            <Form.Control
                                type="number"
                                value={selectedStockProduct.priceRanges[selectedPriceRangeIndex].mrp || ''}
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].mrp = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="MRP"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockCurrentStock">
                            <Form.Label>Current Stock</Form.Label>
                            <Form.Control
                                type="number"
                                value={selectedStockProduct.priceRanges[selectedPriceRangeIndex].stock || 0}
                                readOnly
                                placeholder="Stock Count"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockDate">
                            <Form.Label>Date</Form.Label>
                            <Form.Control
                                type="date"
                               
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].date = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Date"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockInwardStock">
                            <Form.Label>Inward Stock</Form.Label>
                            <Form.Control
                                type="number"
                               
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].inwardStock = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Inward Stock"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockVendorName">
                            <Form.Label>Vendor Name</Form.Label>
                            <Form.Control
                                type="text"
                               
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].vendorname = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Vendor Name"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockInvoiceNumber">
                            <Form.Label>Invoice Number</Form.Label>
                            <Form.Control
                                type="text"
                               
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].invoicenumber = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Invoice Number"
                            />
                        </Form.Group>
                   


                    </>
                )}
                <div className="d-flex justify-content-between">
                    <Button
                        variant="outline-success"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Saving...
                            </>
                        ) : (
                            'Save Stock'
                        )}
                    </Button>
                </div>
            </Form>
        )}
    </Modal.Body>
</Modal>
{/* <Modal show={showStockModal} onHide={handleCloseStockModal} size="md" centered>
    <Modal.Header closeButton>
        <Modal.Title>Manage Stock</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {selectedStockProduct && (
            <Form onSubmit={handleSaveStock}>
                <Form.Group className="mb-3" controlId="formStockPriceRanges">
                    <Form.Label>Price Range</Form.Label>
                    <Form.Control
                        as="select"
                        value={selectedPriceRangeIndex !== null ? selectedPriceRangeIndex : ''}
                        onChange={(e) => setSelectedPriceRangeIndex(e.target.value)}
                    >
                        <option value="" disabled>Select Price Range</option>
                        {selectedStockProduct.priceRanges.map((priceRange, index) => (
                            <option key={index} value={index}>
                                {priceRange.price}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
                {selectedPriceRangeIndex !== null && (
                    <>
                        <Form.Group className="mb-3" controlId="formStockPrice">
                            <Form.Label>Purchase Price</Form.Label>
                            <Form.Control
                                type="number"
                                value={selectedStockProduct.priceRanges[selectedPriceRangeIndex].price}
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].price = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Price"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockMRP">
                            <Form.Label>MRP</Form.Label>
                            <Form.Control
                                type="number"
                                value={selectedStockProduct.priceRanges[selectedPriceRangeIndex].mrp || ''}
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].mrp = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="MRP"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockCurrentStock">
                            <Form.Label>Current Stock</Form.Label>
                            <Form.Control
                                type="number"
                                value={selectedStockProduct.priceRanges[selectedPriceRangeIndex].stock || 0}
                                readOnly
                                placeholder="Stock Count"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockDate">
                            <Form.Label>Date</Form.Label>
                            <Form.Control
                                type="date"
                             
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].date = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Date"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockInwardStock">
                            <Form.Label>Inward Stock</Form.Label>
                            <Form.Control
                                type="number"
                               
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].inwardStock = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Inward Stock"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockVendorName">
                            <Form.Label>Vendor Name</Form.Label>
                            <Form.Control
                                type="text"
                              
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].vendorname = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Vendor Name"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formStockInvoiceNumber">
                            <Form.Label>Invoice Number</Form.Label>
                            <Form.Control
                                type="text"
                                
                                onChange={(e) => {
                                    const newPriceRanges = [...selectedStockProduct.priceRanges];
                                    newPriceRanges[selectedPriceRangeIndex].invoicenumber = e.target.value;
                                    setSelectedStockProduct({ ...selectedStockProduct, priceRanges: newPriceRanges });
                                }}
                                placeholder="Invoice Number"
                            />
                        </Form.Group>
                    </>
                )}
                <div className="d-flex justify-content-between">
                    <Button
                        variant="outline-success"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Saving...
                            </>
                        ) : (
                            'Save Stock'
                        )}
                    </Button>
                </div>
            </Form>
        )}
    </Modal.Body>
</Modal> */}
        <Modal show={showOutwardStockModal} onHide={() => setShowOutwardStockModal(false)} size="md" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                {selectedOutwardStock && selectedOutwardStock.type === 'Outward-stock' ? 'Outward Stock Details' : 'Inward Stock Details'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {selectedOutwardStock && selectedOutwardStock.type === 'Outward-stock' &&(
                    <div>
                        <h5>Scheme Details</h5>
                        <p><strong>Scheme Name:</strong> {selectedOutwardStock.schemeName}</p>
                        <p><strong>Scheme ID:</strong> {selectedOutwardStock.schemeId}</p>
                        <h5>Customer Details</h5>
                        <p><strong>Customer ID:</strong> {selectedOutwardStock.customerId}</p>
                        {/* Add more customer details here if available */}
                    </div>
                )}
                  {selectedOutwardStock && selectedOutwardStock.type === 'Inward-stock' &&(
                    <div>
                        <p><strong>Vendor name:</strong> {selectedOutwardStock.vendorname}</p>
                        <p><strong>Invoice number:</strong> {selectedOutwardStock.invoicenumber}</p>
                        {/* Add more customer details here if available */}
                    </div>
                )}
            </Modal.Body>
        </Modal>
        </Container>
    );
};

export default Inventory;